import {ChangeDetectorRef, Injectable} from '@angular/core';
import {take} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {DialogViewModelCreatorService, MessageViewModel} from 'botato-angular-lib';

/* eslint-disable @typescript-eslint/no-explicit-any*/
@Injectable({
    providedIn: 'root'
})
export class DeactivateMessageService {

    constructor(private dialogViewModelCreatorService: DialogViewModelCreatorService) {
    }

    public deactivateOldCustomMessage(message: MessageViewModel): Subscription | undefined {
        const data = message.data;
        if (data.deactivated !== true) {
            return this.dialogViewModelCreatorService.getDialogViewModelObservable().pipe(take(1)).subscribe((dialogViewModel) => {
                if (data.indexOfMessage === undefined) {
                    data.indexOfMessage = dialogViewModel.messageGroups.findIndex(group => group.messages.includes(message));
                } else {
                    const isOldCustomMessageShouldBeDeactivated = data.deactivated === undefined &&
                        data.indexOfMessage < (dialogViewModel.messageGroups.length - 1);
                    if (isOldCustomMessageShouldBeDeactivated) {
                        data.deactivated = true;
                    }
                }
            });
        }
        return undefined;
    }

    public setUpdateOfLastMessage(data: any, changeDetection: ChangeDetectorRef): Subscription | undefined {
        if (data.updated === true) {
            return undefined;
        }

        return this.dialogViewModelCreatorService.getDialogViewModelObservable().pipe(
            take(1))
            .subscribe((dialogViewModel) => {
                for (const group of dialogViewModel.messageGroups) {
                    for (const message of group.messages) {
                        if (data.responseItemId === message.data?.responseItemId) {
                            message.data.updateMessage = data;
                            data.updated = true;
                            changeDetection.detectChanges();
                            return;
                        }
                    }
                }
            });
    }
}
